<template>
  <span :class="style.heading">Ident</span>
  <div :class="style.inputs">
    <InputStyle
      size="M"
      placeholder="Введите название"
      description="Название в списке"
      v-model="localIntegration.name"
    />
    <InputStyle
      size="M"
      description="Ключ"
      v-model="localIntegration.id"
      readOnly
    />
  </div>
  <div :class="style.buttons">
    <PrimaryButton
      :text="edit ? 'Сохранить' : 'Добавить интеграцию'"
      @click="saveIntegration"
    />
    <SecondaryButton
      text="Удалить"
      v-if="edit"
      :icon="trashIcon"
      @click="$emit('delete')"
    />
  </div>
</template>

<script lang="ts">
import {defineComponent, PropType} from "vue";
import PrimaryButton from "@/elements/UI/button/ButtonStyle/Default/primary/PrimaryButton.vue";
import style from "./settingIntegrations.module.scss";
import SecondaryButton from "@/elements/UI/button/ButtonStyle/Default/secondary/SecondaryButton.vue";
import trashIcon from "$images/icons/button/Name=Trash, Size=16, Tone=Default.svg";
import {identIntegration} from "@/page/setting/integration/IntegrationTypes";
import InputStyle from "@/elements/UI/input/Style/InputStyle.vue";

export default defineComponent({
  name: "SettingIntegrationIDent",
  components: {InputStyle, SecondaryButton, PrimaryButton},
  emits: ["delete", "closeModal"],
  props: {
    integration: {
      type: Object as PropType<identIntegration>,
      default: () => ({})
    },
    edit: {
      type: Boolean,
      default: false
    },
    integrationIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      style,
      trashIcon,
      localIntegration: {
        name: this.integration?.name || "",
        id: this.integration?.id || ""
      }
    };
  },
  async mounted() {
    if (!this.localIntegration.id) {
      await this.generateKey();
    }
  },
  methods: {
    saveIntegration() {
      const integration = this.getIntegration.ident;

      if (!integration) return;

      if (
        this.edit &&
        this.integrationIndex >= 0 &&
        this.integrationIndex < integration.integration.length
      ) {
        integration.integration[this.integrationIndex] = {
          ...this.localIntegration
        };
      } else {
        integration.integration.push({...this.localIntegration});
      }

      this.$emit("closeModal");
    },
    async generateKey(): Promise<void> {
      const letters = "abcdefghijklmnopqrstuvwxyz0123456789!_#(){}*";
      let word = "";

      for (let i = 0; i < 25; i++) {
        word += letters.charAt(Math.floor(Math.random() * letters.length));
      }

      this.localIntegration.id = word;
    }
  },
  computed: {
    getIntegration() {
      return this.$integrationStore.getIntegration;
    }
  },
  watch: {
    integration: {
      immediate: true,
      deep: true,
      handler(newVal) {
        if (!newVal) return;

        this.localIntegration = {
          name: newVal.name || "",
          id: newVal.id || ""
        };
      }
    }
  }
});
</script>
